export default __webpack_public_path__ + "static/media/tokenized.bc7e9ea4.svg";